import { useState } from 'react';
import { sssSorular } from '@/mocks/sss';

export default function SSS() {
  const [acikSoru, setAcikSoru] = useState<number | null>(1);

  const toggleSoru = (id: number) => {
    setAcikSoru(acikSoru === id ? null : id);
  };

  return (
    <section id="sss" className="py-20 md:py-28 bg-[#1A0F0A]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Başlık */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-5 py-2 bg-[#E8B86D]/15 text-[#E8B86D] text-xs font-bold tracking-[0.2em] uppercase rounded-full mb-5 border border-[#E8B86D]/25">
            Sıkça Sorulan Sorular
          </span>
          <h2
            className="font-black italic text-white leading-tight mb-4"
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: "clamp(1.8rem, 4vw, 3rem)",
            }}
          >
            Aklınıza
            <span
              className="ml-3"
              style={{
                background: "linear-gradient(135deg, #C9943A, #E8B86D)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              Takılanlar
            </span>
          </h2>
          <p className="text-white/55 text-sm md:text-base max-w-lg mx-auto font-light">
            Kampanyalarımız ve uygulamalarımız hakkında en çok merak edilen sorular
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-3">
          {sssSorular.map((item) => (
            <div
              key={item.id}
              className={`rounded-xl border transition-all duration-300 overflow-hidden ${
                acikSoru === item.id
                  ? 'border-[#E8B86D]/60 bg-[#2D1810]'
                  : 'border-white/10 bg-white/5 hover:border-[#E8B86D]/30'
              }`}
            >
              {/* Soru Başlığı */}
              <button
                onClick={() => toggleSoru(item.id)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left group cursor-pointer"
              >
                <span className={`font-semibold text-sm md:text-base pr-4 transition-colors duration-300 ${
                  acikSoru === item.id ? 'text-[#E8B86D]' : 'text-white/80 group-hover:text-white'
                }`}>
                  {item.soru}
                </span>
                <span className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${
                  acikSoru === item.id
                    ? 'bg-[#E8B86D] text-[#1A0F0A] rotate-180'
                    : 'bg-white/10 text-white/60 group-hover:bg-[#E8B86D]/20 group-hover:text-[#E8B86D]'
                }`}>
                  <i className="ri-arrow-down-s-line text-lg"></i>
                </span>
              </button>

              {/* Cevap İçeriği */}
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  acikSoru === item.id ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <div className="pt-2 border-t border-white/10">
                    <p className="text-white/60 text-sm md:text-base leading-relaxed pt-4 font-light">
                      {item.cevap}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Alt CTA */}
        <div className="mt-10 text-center">
          <p className="text-white/40 text-sm mb-4 font-light">
            Başka bir sorunuz mu var?
          </p>
          <a
            href="https://wa.me/905001234567"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-7 py-3 bg-[#E8B86D] text-[#1A0F0A] text-sm font-bold rounded-full hover:bg-[#F5D08A] transition-all duration-300 cursor-pointer"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            Hemen Sorun
          </a>
        </div>
      </div>
    </section>
  );
}